import React, { useState, useEffect } from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';
import firebase from 'gatsby-plugin-firebase';

import SEO from '../../seo';
import Wrapper from '../../elements/wrapper';

import UploadIcon from '../../../images/icons/upload-icon.inline.svg';
import TrashIcon from '../../../images/icons/trash.inline.svg';
import { media, TransitionMixin } from '../../helpers';

const StepOneContainer = styled.section`
    .title-container {
        text-align: center;
        margin-bottom: 80px;

        h1 {
            font-size: 3rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 30px;
        }

        p {
            font-size: 1rem;
            font-weight: 400;
            max-width: 950px;
            margin: 0 auto;
            line-height: 1.5;
        }

        h4 {
            font-size: 1.1rem;
            font-style: italic;
            color: #000;
        }

        .progress-bar-container {
            display: flex;
            max-width: 550px;
            margin: 0 auto 40px;
            border-radius: 20px;
            border: 2px solid #000;
            .block {
                height: 20px;
                width: 300px;

                border-left: 2px solid #000;

                &:first-child {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                &:last-child {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                }

                &.filled {
                    background-color: #f74d33;
                }
            }
        }
    }
    .design-basics-wrapper {
        max-width: 950px;
        margin: 20px;
        ${media.small`display: flex;`}
        ${media.medium`margin: 0 auto 60px;`}

        .logo-upload-container {
            flex: 1;
            margin-bottom: 30px;
            ${media.small`margin-right: 70px; margin-bottom: 0px;`}

            .inner-wrap {
                > p {
                    font-weight: 800;
                    color: #000;
                    margin: 0 0 10px;
                }
                .logo-square {
                    height: 184px;
                    width: 100%;
                    background-color: #f2f0eb;
                    margin-bottom: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #702716;
                }

                .links-footer {
                    display: flex;

                    .link {
                        flex: 1;
                        display: inline-flex;
                        align-items: flex-start;

                        label {
                            line-height: 1;
                            color: #702716;
                            text-decoration: underline;
                            font-size: 0.8rem;

                            &:hover {
                                cursor: pointer;
                                opacity: 0.7;
                            }
                        }

                        input {
                            display: none;
                        }

                        svg {
                            path {
                                fill: #702716;
                            }
                        }
                    }
                }
            }
        }
        .uploaded-files-container {
            flex: 1;
            margin-bottom: 40px;
            ${media.medium`margin-bottom: 0px;`}
            > p {
                font-weight: 800;
                color: #000;
                margin: 0 0 10px;
            }

            ul {
                padding: 0;
                margin: 0;
                list-style: none;

                li {
                    &.no-files {
                        font-style: italic;
                        background-color: transparent;
                    }
                    background-color: #f2f0eb;
                    position: relative;
                    top: 4px;
                    margin-bottom: 10px;
                    border-radius: 5px;
                    svg {
                        position: relative;
                        top: 4px;
                    }
                    .inner-wrap {
                        padding: 20px;
                        display: flex;
                        align-items: center;
                        .icon {
                            margin-right: 10px;
                        }
                        .remove {
                            flex: 1;
                            text-align: right;

                            button {
                                line-height: 1;
                                border: none;
                                background-color: transparent;

                                svg {
                                    path {
                                        fill: #702716;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .footer-nav-wrapper {
        display: flex;
        max-width: 950px;
        align-items: center;
        margin: 20px 20px 40px;

        ${media.medium`margin: 0px auto 70px;`}

        .left-container {
            flex: 1;

            a {
                color: #000;
            }
        }
        .right-container {
            flex: 1;
            text-align: right;

            a {
                background-color: #f74c34;
                color: #fff;
                font-weight: bold;
                border-radius: 5px;
                display: inline-block;
                padding: 15px 20px;
                border: 1px solid #f74c34;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                min-width: 185px;
                text-align: center;
                text-decoration: none;
                ${TransitionMixin('.25s')};

                &:hover {
                    background-color: #fff;
                    color: #f74c34;
                }
            }
        }
    }

    .info-tab-container {
        .info-tab {
            max-width: 550px;
            background-color: #f2f0eb;
            box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
            border-radius: 5px;
            padding: 40px;
            position: relative;
            margin: 0 auto;
            .icon {
                position: absolute;
                top: -15px;
                left: -10px;
                padding: 10px 20px;
                background-color: #f74d33;
                border-radius: 50%;
                font-weight: bold;
                color: #fff;
                font-size: 2rem;
                ${media.large`left: -20px;`}
            }
            p {
                font-weight: bold;
                text-align: left;
                margin: 0;
                color: #000;
            }
        }
    }
`;

// Form
const StepOne = ({ brandedSettings, setBrandedSettings, brandedInit }) => {
    const [files, setFiles] = useState([]);
    // this is what gets passed to our master object
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const onFileChange = async (e) => {
        console.log('uploadedFiles', uploadedFiles);
        e.persist();
        let fileArray = [...e.target.files];
        fileArray &&
            fileArray.length > 0 &&
            (await fileArray.map((file, index) => {
                const newFile = file;
                newFile['id'] = Math.random();

                Promise.resolve(
                    setFiles((prevState) => [...prevState, newFile])
                );
            }));
    };

    async function handleInputChange(e) {
        await onFileChange(e).then((result) => {
            console.log(files, result);
        });
    }
    const onUploadSubmission = () => {
        // e.preventDefault(); // prevent page refreshing
        const promises = [];
        files.forEach((file) => {
            const uploadTask = firebase
                .storage()
                .ref()
                .child(`branded-upload-images/${file.name}`)
                .put(file);

            promises.push(uploadTask);

            uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                (snapshot) => {
                    const progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    if (snapshot.state === firebase.storage.TaskState.RUNNING) {
                        console.log(`Progress: ${progress}%`);
                    }
                },
                (error) => console.log(error.code),
                async () => {
                    const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
                    const fileName = await uploadTask.snapshot.ref.name;
                    // do something with the url
                    console.log(uploadTask.snapshot.ref);
                    console.log(downloadURL);

                    const newFile = {
                        title: fileName,
                        url: downloadURL,
                    };

                    setUploadedFiles((oldArray) => [...oldArray, newFile]);
                }
            );
        });
        Promise.all(promises)
            .then(() => {
                // once all files are added, update master object
                // console.log('wow', uploadedFiles);
                console.log('setting files to none');
                setFiles([]);
            })
            .then(() => {})
            .catch((err) => console.log(err.code));
    };

    function removeFile(fileName) {
        let newArray = brandedSettings.reference_files.filter(
            (file) => file.title !== fileName
        );
        setBrandedSettings({
            ...brandedSettings,
            reference_files: newArray,
        });

        console.log('uploadedFiles', uploadedFiles);
    }

    // auto uploads on input change
    useEffect(() => {
        if (files.length > 0) {
            onUploadSubmission();
        }
    }, [files]);

    // chnages master object when uploaded files is altered
    useEffect(() => {
        if (uploadedFiles.length > 0) {
            console.log(uploadedFiles);
            setBrandedSettings({
                ...brandedSettings,
                reference_files: uploadedFiles,
            });
        }
    }, [uploadedFiles]);

    useEffect(() => {
        brandedInit();
        if (typeof window !== 'undefined') {
            let savedFiles = JSON.parse(
                localStorage.getItem('brandedProgress')
            );
            setUploadedFiles(savedFiles.reference_files);
        }
    }, []);

    return (
        <StepOneContainer>
            <SEO title="Step 1 –– Branded" />
            <Wrapper className="title-container">
                <h4>Step 1</h4>
                <div className="progress-bar-container">
                    <div className="block filled"></div>
                    <div className="block"></div>
                    <div className="block"></div>
                    <div className="block"></div>
                </div>
                <h1>Logos &amp; files</h1>
                <p>
                    Upload a logo file and tell us a little bit about your
                    products. This can include the event taking place, the
                    patterns and colours or any other relecant information.
                </p>
            </Wrapper>
            <Wrapper className="design-basics-wrapper">
                <div className="logo-upload-container">
                    <div className="inner-wrap">
                        <p>Upload logo files</p>
                        <div className="logo-square">
                            <UploadIcon />
                        </div>
                        <div className="links-footer">
                            <div className="link">
                                <label>
                                    Select Files{' '}
                                    {files.length > 0 && (
                                        <span className="count">
                                            ({files.length})
                                        </span>
                                    )}
                                    <input
                                        type="file"
                                        multiple
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="uploaded-files-container">
                    <p>Uploaded Files</p>
                    <ul>
                        {brandedSettings.reference_files &&
                        brandedSettings.reference_files.length > 0 ? (
                            brandedSettings.reference_files.map(
                                (file, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="inner-wrap">
                                                <span className="icon">
                                                    <UploadIcon />
                                                </span>
                                                <span className="title">
                                                    {file.title}
                                                </span>
                                                <span className="remove">
                                                    <button
                                                        onClick={() =>
                                                            removeFile(
                                                                file.title
                                                            )
                                                        }
                                                    >
                                                        <TrashIcon />
                                                    </button>
                                                </span>
                                            </div>
                                        </li>
                                    );
                                }
                            )
                        ) : (
                            <li className="no-files">
                                Uploaded files will show up here.
                            </li>
                        )}
                    </ul>
                </div>
            </Wrapper>
            <Wrapper className="footer-nav-wrapper">
                <div className="left-container">
                    <div className="link">
                        <Link to="/branded"> {'<'} Go Back</Link>
                    </div>
                </div>
                <div className="right-container">
                    <div className="link">
                        <Link to="/branded/step-2"> Next Step</Link>
                    </div>
                </div>
            </Wrapper>
            <Wrapper className="info-tab-container">
                <div className="info-tab">
                    <div className="icon">!</div>
                    <p>
                        Vector files (.ai and .eps) work best and a brand guide
                        is helpful, but not required.
                    </p>
                </div>
            </Wrapper>
        </StepOneContainer>
    );
};

export default StepOne;
